import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  withStyles,
  CardContent,
  CardActions,
  Button,
  CircularProgress,
} from '@material-ui/core';
import {
  addComment,
  changeStatus,
} from '@pingum/app-state-management/event/actions';
import StatusAssignment from '../../../widgets/StatusAssignment';
import noChangeStatus from './noChangeStatus';
import styles from './styles';

class AddCommentCard extends React.Component {
  constructor(props) {
    super(props);

    this.noChangeStatus = noChangeStatus;

    this.state = {
      selectedStatus: this.noChangeStatus,
      comment: '',
      assignment: '',
      isValidStatus: true,
      isValidAssignment: true,
      workflowStatus: null,
    };
  }

  handleSelectedStatusChange = (selectedStatus) => {
    if (selectedStatus.id === this.props.selectedEvent.currentEventStatus.status.id) {
      return;
    }
    this.setState({
      selectedStatus,
      isValidStatus: true,
    });
  }

  handleWorkflowStatusChange = (workflowStatus) => {
    this.setState({
      workflowStatus,
      isValidAssignment: true,
    });
  }

  handleAssignmentChange = (user) => {
    let { assignment: updatedUserData } = this.state;
    const { workflowStatus } = this.state;
    const userInList = updatedUserData.indexOf(user) >= 0;
    if (userInList) {
      updatedUserData = updatedUserData.replace(user, '');
    } else {
      updatedUserData = updatedUserData.concat(`@[${user.userFullName}](${user.auth0UserId})`);
    }

    this.setState({
      assignment: updatedUserData,
      isValidAssignment: !workflowStatus || !workflowStatus.requiredAssignment || !!updatedUserData,
    });
  }

  handleCommentChange = (e) => {
    const comment = e.target.value;
    const { requireComment } = this.state.selectedStatus;
    this.setState({
      comment,
      isValidStatus: !(requireComment && comment.trim().length === 0),
    });
  }

  handleSuccessfulUpdate = () => {
    this.setState({
      comment: '',
      selectedStatus: this.noChangeStatus,
      isValidStatus: true,
      isValidAssignment: true,
      workflowStatus: null,
    });
  }

  handleUpdateClick = () => {
    let allValid = true;
    if (this.state.selectedStatus.requireComment && this.state.comment.trim().length === 0) {
      this.setState({ isValidStatus: false });
      allValid = false;
    }
    if (this.state.workflowStatus && this.state.workflowStatus.requiredAssignment && !this.state.assignment) {
      this.setState({ isValidAssignment: false });
      allValid = false;
    }
    if (!allValid) {
      return false;
    }

    if (this.state.comment && this.state.selectedStatus.id < 0) {
      return this.props.addComment(
        this.props.selectedEvent.id,
        { comment: this.state.comment },
        this.handleSuccessfulUpdate,
      );
    }

    return this.props.changeStatus(
      this.props.selectedEvent.id,
      {
        statusId: this.state.selectedStatus.id,
        statusComment: this.state.comment,
        completeEvent: this.state.selectedStatus.endingStatus,
        assignment: this.state.assignment || null,
      },
      this.handleSuccessfulUpdate,
    );
  }

  canUpdate = () => (this.state.selectedStatus.id > -1 || this.state.comment || !this.state.isValidStatus)

  render() {
    const {
      classes,
      isLoading,
      selectedEvent,
    } = this.props;
    const {
      comment,
      assignment,
      selectedStatus,
      isValidStatus,
      isValidAssignment,
    } = this.state;

    return (
      <div className={classes.container}>
        <div className={classes.card}>
          <CardContent
            classes={{ root: classes.cardContentRoot }}
          >
            <StatusAssignment
              allowNoStatusChange
              showStatusCommentField
              comment={comment}
              assignment={assignment}
              selectedStatus={selectedStatus}
              event={selectedEvent}
              eventStatus={selectedEvent.currentEventStatus}
              isValidStatus={isValidStatus}
              isValidAssignment={isValidAssignment}
              handleSelectedStatusChange={this.handleSelectedStatusChange}
              handleWorkflowStatusChange={this.handleWorkflowStatusChange}
              handleAssignmentChange={this.handleAssignmentChange}
              handleCommentChange={this.handleCommentChange}
            />
          </CardContent>
          <CardActions className={classes.actions}>
            <div className={classes.updateButtonContainer}>
              <Button
                size="small"
                color="primary"
                disabled={!this.canUpdate() || isLoading}
                onClick={this.handleUpdateClick}
                variant="contained"
              >
                Update
              </Button>
              {
                isLoading
                  && (
                    <CircularProgress
                      size={24}
                      className={classes.updateProgress}
                    />
                  )
              }
            </div>
          </CardActions>
        </div>
      </div>
    );
  }
}

AddCommentCard.propTypes = {
  classes: PropTypes.object,
  addComment: PropTypes.func,
  selectedEvent: PropTypes.object,
  changeStatus: PropTypes.func,
  isLoading: PropTypes.bool,
};

AddCommentCard.defaultProps = {
  classes: {},
  addComment: () => {},
  selectedEvent: {},
  changeStatus: () => {},
  isLoading: false,
};

export const mapStateToProps = (state) => ({
  selectedEvent: state.event.selectedEvent,
  isLoading:
    state.event.isAddingComment
    || state.event.isChangingStatus,
});

export const mapDispatchToProps = (dispatch) => ({
  addComment: (id, comment, successCallback) => dispatch(addComment(id, comment, successCallback)),
  changeStatus: (id, status, successCallback) => dispatch(changeStatus(id, status, successCallback)),
});

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddCommentCard));
